<template>
  <div class="followBox">
    <div class="follow">
      <el-date-picker
        v-model="dateValue"
        type="month"
        size="mini"
        :clearable="false"
      >
      </el-date-picker>
    </div>
    <el-calendar v-model="dateValue"> </el-calendar>
  </div>
</template>
<script>
import { dateFtt } from "@/assets/js/utils";
export default {
  data() {
    return {
      dateValue: new Date(),
    };
  },
  methods: {},
  created() {
    //    format="yyyy-MM"
    // value-format="yyyy-MM"
    // this.dateValue = dateFtt("yyyy-MM", new Date());
  },
};
</script>
<style lang="scss" scoped>
.followBox {
  padding-top: 10px;

  .follow {
    text-align: center;
  }

  /*一 二 头部*/
  ::v-deep .el-calendar-table thead th {
    padding-left: 12px;
    text-align: left !important;
    font-size: 13px;
    // color: #fff;
  }
  /* 去除边框 */
  ::v-deep .el-calendar-table tr td:first-child {
    border: none;
  }
  ::v-deep .el-calendar-table tr:first-child td {
    border: none;
  }
  ::v-deep .el-calendar-table__row td {
    border: none;
  }

  ::v-deep .el-calendar {
    font-size: 14px;
    .el-calendar-day {
      height: 35px;
      text-align: center;
      border: none;
      // margin: 5px;
      // border-bottom: 2px solid #e9e9e9;
    }
    .el-calendar__header {
      display: none;
    }
  }
}
</style>
